import { ShareIcon } from '@heroicons/react/24/outline';
import { toast } from 'react-hot-toast';
import ConnectButton from '../ConnectButton';

const StreamInfo = ({
  stream,
  user,
  handleShare,
  viewerCount,
  isStreamCreator,
  playbackError,
  endingStream,
  handleEndStream
}) => {
  const formatAddress = (address) => {
    if (!address) return 'Anonymous';
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  };

  return (
    <div className="bg-gray-800 rounded-lg p-4">
      <div className="flex items-start gap-4">
        <img
          src={stream.creator?.avatar || `https://placehold.co/64x64/8B5CF6/ffffff?text=${stream.creator?.address?.charAt(2)}`}
          alt={formatAddress(stream.creator?.address)}
          className="w-16 h-16 rounded-full"
        />
        <div className="flex-1">
          <div className="flex justify-between items-start">
            <div>
              <h1 className="text-2xl font-bold text-white mb-1">{stream.title}</h1>
              {/* Display username if available, otherwise fallback to formatted address */}
              <p className="text-purple-400 hover:text-purple-300 cursor-pointer">
                {stream.creator?.username || formatAddress(stream.creator?.address)}
              </p>
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={handleShare}
                className="p-2 bg-gray-700 hover:bg-gray-600 rounded-lg transition-colors"
                title="Share stream"
              >
                <ShareIcon className="h-5 w-5 text-white" />
              </button>
              {!user?.isConnected && <ConnectButton />}
            </div>
          </div>

          <div className="mt-4">
            <div className="flex items-center gap-4 text-sm">
              <span className="text-red-500">
                {viewerCount} {viewerCount === 1 ? 'viewer' : 'viewers'}
              </span>
              {stream.category && (
                <span className="text-gray-400">
                  Category: {stream.category}
                </span>
              )}
            </div>
            {stream.description && (
              <p className="mt-2 text-gray-300">{stream.description}</p>
            )}
          </div>

          {isStreamCreator && stream.status === 'live' && (
            <div className="mt-4">
              <button
                onClick={() => {
                  if (window.confirm('Are you sure you want to end the stream?')) {
                    handleEndStream();
                  }
                }}
                disabled={endingStream}
                className={`px-4 py-2 ${endingStream ? 'bg-red-400' : 'bg-red-600 hover:bg-red-700'} text-white rounded-lg transition-colors flex items-center gap-2`}
              >
                {endingStream && (
                  <div className="w-4 h-4 border-t-2 border-white rounded-full animate-spin"></div>
                )}
                {endingStream ? 'Ending Stream...' : 'End Stream'}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StreamInfo;
